// State variables
let currentIndex = 0;
let cardWidth = 0;
let visibleCards = 1;
let maxIndex = 0;

// DOM elements
const container = document.querySelector(".hp-reviews-cards-container");
const leftArrow = document.querySelector(".reviews-left-arrow");
const rightArrow = document.querySelector(".reviews-right-arrow");
const cards = document.querySelectorAll(".hp-reviews-card");

// Calculate dimensions function
function calculateDimensions() {
  if (!container || cards.length === 0) return;

  const containerWidth = container.offsetWidth;
  cardWidth = cards[0] ? cards[0].offsetWidth : 0;

  // Calculate how many cards are visible
  visibleCards = Math.floor(containerWidth / cardWidth);

  // Ensure we don't go beyond available cards
  maxIndex = Math.max(0, cards.length - visibleCards);
}

// Scroll to specific slide function
function scrollToSlide() {
  if (!container) return;
  
  const scrollAmount = currentIndex * cardWidth;
  container.scrollTo({
    left: scrollAmount,
    behavior: "smooth",
  });
}

// Update current index based on scroll position
function updateCurrentIndex() {
  if (!container) return;
  
  const scrollLeft = container.scrollLeft;
  currentIndex = Math.round(scrollLeft / cardWidth);
  // Ensure currentIndex doesn't exceed maxIndex
  currentIndex = Math.min(currentIndex, maxIndex);
}

// Update arrow states function
function updateArrowStates() {
  if (!leftArrow || !rightArrow) return;
  
  // Disable left arrow if at first slide
  if (currentIndex === 0) {
    leftArrow.classList.add("disabled");
  } else {
    leftArrow.classList.remove("disabled");
  }

  // Disable right arrow if at last slide
  if (currentIndex >= maxIndex) {
    rightArrow.classList.add("disabled");
  } else {
    rightArrow.classList.remove("disabled");
  }
}

// Next slide function
function nextSlide() {
  if (currentIndex < maxIndex) {
    currentIndex++;
    scrollToSlide();
    updateArrowStates();
  }
}

// Previous slide function
function previousSlide() {
  if (currentIndex > 0) {
    currentIndex--;
    scrollToSlide();
    updateArrowStates();
  }
}

// Setup event listeners function
function setupEventListeners() {
  if (!leftArrow || !rightArrow || !container) return;
  
  leftArrow.addEventListener("click", previousSlide);
  rightArrow.addEventListener("click", nextSlide);

  // Listen for scroll events to update arrow states when dragging
  container.addEventListener("scroll", () => {
    updateCurrentIndex();
    updateArrowStates();
  });
}

// Initialize carousel function
function initReviewsCarousel() {
  if (!container || !leftArrow || !rightArrow) return;

  calculateDimensions();
  setupEventListeners();
  updateArrowStates();

  // Recalculate on window resize
  window.addEventListener("resize", () => {
    calculateDimensions();
    updateArrowStates();
  });
}

// Initialize the carousel when DOM is loaded
document.addEventListener("DOMContentLoaded", initReviewsCarousel);
